import React, { useState } from "react";

import { Link, useNavigate, useParams } from "react-router-dom";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import { useQuery } from "@tanstack/react-query";

import { useSelector } from "react-redux";

import { Skeleton } from "@mui/material";
import Header from "../../Header";
import Sidebar from "../../Sidebar";

// import dayjs from "dayjs";
// import { Table } from "antd";
import { getInvoiceItemDetail } from "../../../connections/getInvoiceItemDetail";
import { deleteInvoiceItem } from "../../../connections/deleteInvoiceItem";
import { toast } from "react-toastify";
import { imagesend } from "../../imagepath";
const ShowInvoiceItem = () => {
  const {
    user: { user },
  } = useSelector((store) => store);
  const { id } = useParams();
  const [deleteId, setDeleteId] = useState(null);
  const navigate = useNavigate();
  const { data: invoiceItemDetailData, isLoading } = useQuery({
    queryKey: ["getInvoiceItemDetail", id],
    queryFn: () => getInvoiceItemDetail(user?.token, id),
    enabled: !!id,

    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
  const handleDeleteInvoiceItem = async (e) => {
    e.preventDefault();
    const data = await deleteInvoiceItem(user?.token, deleteId);
    if (data.status.status === "SUCCESS") {
      toast.success("Invoice Item Deleted Successfully");
      navigate(`/admin/invoice-details/${invoiceItemDetailData?.invoice?.id}`);
    }
  };
  // const columns = [
  //   {
  //     title: "Name",
  //     dataIndex: "name",
  //     key: "name",
  //   },
  //   {
  //     title: "Description",
  //     dataIndex: "description",
  //     key: "description",
  //     render: (text) => text || "N/A", // Display "N/A" if null
  //   },
  //   {
  //     title: "Type",
  //     dataIndex: "invoice_itemable_type",
  //     key: "invoice_itemable_type",
  //   },
  //   {
  //     title: "Amount",
  //     dataIndex: "amount",
  //     key: "amount",
  //     render: (amount) => `₹${amount.toFixed(2)}`, // Format amount with currency symbol
  //   },
  //   {
  //     title: "Quantity",
  //     dataIndex: "quantity",
  //     key: "quantity",
  //     render: (text) => text || "N/A",
  //   },
  //   {
  //     title: "Discount",
  //     dataIndex: "discount",
  //     key: "discount",
  //     render: (text) => text || "N/A",
  //   },

  //   {
  //     title: "Refund",
  //     dataIndex: "refund",
  //     key: "refund",
  //     render: (refund) => (refund ? "Yes" : "No"),
  //   },
  // ];

  return (
    <>
      <Header />
      <Sidebar activeClassName="invoice-list" />
      <>
        <div className="page-wrapper">
          <div className="content">
            {/* Page Header */}
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item active">
                      <Link to={-1}>Invoice Item Details</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <i className="feather-chevron-right">
                        <FeatherIcon icon="chevron-right" />
                      </i>
                    </li>
                    <li className="breadcrumb-item active">{id}</li>
                  </ul>
                </div>
              </div>
            </div>
            {/* /Page Header */}
            <div className="row">
              <div className="col-sm-12">
                <div className="card card-table show-entire">
                  <div className="card-body">
                    {/* content Header */}
                    <div className="page-table-header mb-2">
                      <div className="row align-items-center">
                        <div className="col">
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                            className="doctor-table-blk"
                          >
                            <h3>Invoice Item Details</h3>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                              }}
                              className="doctor-search-blk"
                            >
                              <button
                                className="btn btn-sm btn-primary d-flex align-items-center justify-content-center"
                                style={{
                                  minWidth: "100px",
                                  padding: "6px 12px",
                                  borderRadius: "6px",
                                }}
                                onClick={() => {
                                  navigate(
                                    "/admin/update-invoice-item-details",
                                    {
                                      state: invoiceItemDetailData,
                                    }
                                  );
                                }}
                              >
                                <i className="far fa-edit me-2" />
                                Edit
                              </button>

                              <button
                                className="btn btn-sm btn-danger d-flex align-items-center justify-content-center"
                                style={{
                                  minWidth: "100px",
                                  padding: "6px 12px",
                                  borderRadius: "6px",
                                }}
                                data-bs-toggle="modal"
                                data-bs-target="#delete_patient"
                                onClick={() => {
                                  setDeleteId(invoiceItemDetailData?.id);
                                }}
                              >
                                <i className="fa fa-trash-alt me-2" />
                                Delete
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {isLoading ? (
                      <div>
                        <Skeleton
                          variant="rectangular"
                          width="100%"
                          height={430} // Same height as your chart
                        />
                      </div>
                    ) : (
                      <div className="content-details">
                        <div className="col-lg-12">
                          <div className="card-box">
                            <div className="card-block">
                              <ul className="personal-info">
                                <li className="pb-1">
                                  <span className="title">Name:</span>
                                  <span className="text">
                                    {invoiceItemDetailData?.name || "Empty"}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Description:</span>
                                  <span className="text">
                                    {invoiceItemDetailData?.description ||
                                      "N/A"}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Type:</span>
                                  <span className="text">
                                    {invoiceItemDetailData?.invoice_itemable_type ||
                                      "Empty"}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Amount:</span>
                                  <span className="text">
                                    {invoiceItemDetailData?.amount
                                      ? `₹${invoiceItemDetailData.amount.toFixed(
                                          2
                                        )}`
                                      : "Empty"}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Quantity:</span>
                                  <span className="text">
                                    {invoiceItemDetailData?.quantity || "N/A"}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Discount:</span>
                                  <span className="text">
                                    {invoiceItemDetailData?.discount || "N/A"}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Refund:</span>
                                  <span className="text">
                                    {invoiceItemDetailData?.refund
                                      ? "Yes"
                                      : "No"}
                                  </span>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                      // <div className="content-details">
                      //   <div style={{ marginLeft: 20 }} className="row">
                      //     <div className="table-responsive">
                      //       <Table
                      //         columns={columns}
                      //         dataSource={[invoiceItemDetailData]}
                      //         pagination={false}
                      //         scroll={{ x: "max-content" }}
                      //       />
                      //     </div>
                      //   </div>
                      // </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          id="delete_patient"
          className="modal fade delete-modal"
          role="dialog"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body text-center">
                <img src={imagesend} alt="#" width={50} height={46} />
                <h3>Are you sure want to delete this ?</h3>
                <div className="m-t-20">
                  {" "}
                  <Link
                    to="#"
                    className="btn btn-white"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </Link>
                  <button
                    onClick={handleDeleteInvoiceItem}
                    type="submit"
                    className="btn btn-danger"
                    data-bs-dismiss="modal"
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </>
  );
};

export default ShowInvoiceItem;
